export const END_POINTS = {
  AUTH: {
    USER: "user",
    LOGIN: "auth/login",
    FORGOT_PASSWORD: "auth/forgot-password",
    RESET_PASSWORD: "auth/reset-password",
    VERIFY: "auth/verify",
    RESEND_OTP: "auth/resend-otp",
    SIGN_UP: "auth/register",
    BANK_ACCOUNTS: "auth/BankAccounts",
    SERVICE_INFO: "service-info",
    SIGN_S3_URL: (url: string) => `auth/pre-signed-url?url=${url}`,
  },
  KYC: {
    GST: {
      FETCH: (gstNumber: string) => `business/fetch-gst-details/${gstNumber}`,
      SAVE: `business`,
      SAVE_OFFLINE: `business/gst-offline`,
      FETCH_BUSINESS_DETAIL: `business`,
      FETCH_DOCUMENTS: `business-documents`,
      UPLOAD_DOC: (fileType: string) => `business/upload/${fileType}`,
      MARK_DOC_COMPLETE: "business/business-documents/completed",
    },
    AADHAAR: {
      OTP: "business/verify-uidai",
      VERIFY: "business/verify-uidai-otp",
      PAN_VERIFY: (panNumber: string) => `business/verify-pan/${panNumber}`,
      MARK_KYC_DOC_COMPLETE: `business/kyc-documents/completed`,
      SAVE_AADHAAR_OFFLINE: `business/save-aadhaar-manual`,
      DIGILOCKER_VERIFICATION: "auth/document-verification/initiate",
      DIGILOCKER_VERIFICATION_STATUS: (id: string) =>
        `auth/document-verification/fetch/${id}`,
      SAVE_DIGILOCKER_DETAILS: `business/save-digilocker-details`,
    },
    BANK: {
      FETCH: (type: string) => `banks?bankType=${type}`,
      FETCH_BRANCH: (bankId: string) => `bank-branches/${bankId}`,
      SAVE_BANK: `business/bank-details`,
      SAVE_OSV: `business/bank-osv`,
    },
  },
  DASHBOARD: {
    NOTIFICATION: {
      GET: (page: number, limit: number) =>
        `notification?page=${page}&limit=${limit}`,
      MARK_ALL_AS_READ: `notification/read`,
      UNREAD_COUNT: `notification/unread-count`,
      MARK_AS_OPEN: (id: string) => `notification/open/${id}`,
    },
    GET_DASHBOARD_BALANCES: "auth/dashboard",
    FETCH_AVAILABLE_RECEIVABLE: (id: string) =>
      `invoice/fetch-available-receivable/${id}`,
    UPLOAD_NEW_INVOICE: {
      UPLOAD: "invoice/upload",
      VALIDATE: (id: string) => `invoice/validate/${id}`,
      UPDATE_PAYMENT_TERMS: (id: string) => `invoice/payment-terms/${id}`,
      SUBMIT_INVOICE: (id: string) => `invoice/submit/${id}`,
      INVITE: `user/invite`,
      FIND_BY_GST: (gstNumber: string) => `invoice/buyer/${gstNumber}`,
      MANUAL_INVOICE: `invoice/manual-invoice`,
    },
    INVOICE: {
      GET_CREATED_INVOICES: (
        page: number,
        limit: number,
        type: string,
        status: string
      ) =>
        `invoice/requests/created?page=${page}&limit=${limit}&type=${type}&status=${status}`,
      GET_RECEIVED_INVOICES: (
        page: number,
        limit: number,
        type: string,
        status: string
      ) =>
        `invoice/requests/received?page=${page}&limit=${limit}&type=${type}&status=${status}`,
      GET_CREATED_INVOICES_BY_ID: (id: string) =>
        `invoice/requests/created/${id}`,
      GET_RECEIVED_INVOICES_BY_ID: (id: string) =>
        `invoice/requests/received/${id}`,
      REJECT_CREATED_INVOICE: (id: string) => `invoice/reject/${id}`,
      CANCEL_CREATED_INVOICE: (id: string) => `invoice/cancel/${id}`,
      REQUEST_REVIEW: (id: string) => `invoice/review-request/${id}`,
      APPROVE_REQUEST_REVIEW: (id: string) => `invoice/review-request/${id}`,
      ADD_NOTE: (id: string) => `invoice/note/${id}`,
      ADD_NOTE_MANUALLY: (id: string) => `invoice/manually-note/${id}`,
      DELETE_NOTE: (id: string) => `invoice/delete-note/${id}`,
    },
    MAKE_PAYMENT: {
      GET_RECEIVABLES: (id: string) => `invoice/receivables/${id}`,
      SEND_OTP_TO_MAKE_PAYMENT: (id: string) => `invoice/approve/otp/${id}`,
      VERIFY_OTP_TO_MAKE_PAYMENT: (id: string) => `invoice/approve/${id}`,
    },
    NEW_CONNECTIONS: {
      GET_RECEIVED_CONNECTIONS: "connection/received",
      ACCEPT_CONNECTION: (id: string) => `connection/accept/${id}`,
      REJECT_CONNECTION: (id: string) => `connection/reject/${id}`,
    },
  },
  BILLINGS: {
    GET_FEE_LIST: (
      page: number,
      limit: number,
      txnId: string,
      startDate: string,
      endDate: string
    ) =>
      `invoice/fee?page=${page}&limit=${limit}&transactionId=${txnId}&startDate=${startDate}&endDate=${endDate}`,
    GET_INVOICE_LIST: (status: string, page: number, limit: number) =>
      `invoice/billings?page=${page}&limit=${limit}`,
  },
  TICKET: {
    CREATE: `ticket`,
    TICKET_TYPE: `ticket/type`,
    TICKET_CATEGORY: `ticket/get-category`,
    TICKET_SUB_CATEGORY: `ticket/get-subcategory`,
    TICKET_DETAIL: (id: string) => `ticket/${id}`,
    LIST: (page: number, limit: number) =>
      `ticket/own?page=${page}&limit=${limit}`,
    SEND_MESSAGE: (id: string) => `ticket/message-user/${id}`,
  },

  // ********************** AFFILIATE ***********************
  AFFILIATE: {
    DASHBOARD: {
      GRAPH: `user/affiliate/monthly-commission`,
      All: (startDate: string, endDate: string) =>
        `user/affiliate/dashboard?startDate=${startDate}&endDate=${endDate}`,
    },
    COMMISSION: `user/affiliate/commission-history`,
    SETTLEMENT: `user/affiliate/commission-settlement-record`,
    INVIATATION: `invite/business`,
    INVIATATION_LIST: (page: number, limit: number) =>
      `invite/business?page=${page}&limit=${limit}`,
    BANK_ACCOUNTS: {
      CREATE: `affiliate-banks`,
      GET_BANKS: `affiliate-banks`,
      UPDATE_BANK: (id: string) => `affiliate-banks/${id}`,
      TOGGLE_BANK_STATUS: (id: string) => `affiliate-banks/toggle/${id}`,
    },
  },
  // ********************** SALES USER ***********************
  SALES_USER: {
    SALES: {
      CREATE: `/sales-user/create-affiliate`,
      LIST: `/sales-user/created-affiliate`,
    },
    GET_AFFILIATE_INVITATIONS: (affiliateId: string) =>
      `api/sales-user/create-affiliate/${affiliateId}/invitations`,
    COMMISSION_SETTLEMENT_RECORD: `sales-user/commission-settlement-record`,
    BANK_ACCOUNTS: {
      CREATE: `user-sales-banks`,
      GET_BANKS: `user-sales-banks`,
      UPDATE_BANK: (id: string) => `user-sales-banks/${id}`,
      TOGGLE_BANK_STATUS: (id: string) => `user-sales-banks/toggle/${id}`,
    },
    DASHBOARD: `/sales-user/dashboard`,
    INVIAT_BUSINESSES_LIST: (
      page: number,
      limit: number,
      affiliateId: string
    ) =>
      `admin/affiliate/invitations?page=${page}&limit=${limit}&affiliateId=${affiliateId}`,
  },
};
